import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Aside from "../aside";
import TablePreloader from "../../../assets/preloaders/TablePreloader";

import { GetUserServices, } from "../../../../store/actions/kalapost";
import { toggleSidebar } from "../../../../store/actions/layout";
import { getPaySerivece } from "../../../../services/profileService";


const Orders = () => {
	const dispatch = useDispatch();
	const { isSidebarOpened } = useSelector((state) => state.layout);

	const [loading, setLoading] = useState(true);
	const [section, setSection] = useState(1);
	const [services, setServices] = useState([]);

	useEffect(() => {
		window.scrollTo(0, 0);
		GetServices("current", 1);
	}, []);

	const handleNext = (number) => {
		setSection(number);
	};
	const GetServices = async (type, number) => {
		handleNext(number);
		const res = await GetUserServices(type);
		res.status && setServices(res.data);
		setLoading(false);
	};
	const handlePayService = async (trackingNumber) => {
		const res = await getPaySerivece(trackingNumber);
		if (!res.error) {
			// const dataUrl = `data:text/html,${encodeURIComponent(res.data)}`;

			// Open a new tab with the data URL
			const newTab = window.open(res.data, '_blank');

			if (newTab) {
				newTab.document.title = 'Server Response'; // Set the title of the new tab
				newTab.document.write(res.data);
			} else {
				console.error('Failed to open new tab. Make sure your browser allows pop-ups.');
			}
		}
	};

	return (
		<section className="container">
			<div className="container__row">
				<Aside />
				<main
					className="main__container main__container--orders"
					onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
				>
					<div className="tabbar">
						<div className="tab">
							<button
								className={section === 1 ? "tablinks active" : "tablinks"}
								onClick={() => GetServices("current", 1)}
							>
								جاری
							</button>
							<button
								className={section === 2 ? "tablinks active" : "tablinks"}
								onClick={() => GetServices("receive", 2)}
							>
								تحویل شده
							</button>
							<button
								className={section === 3 ? "tablinks active" : "tablinks"}
								onClick={() => GetServices("return", 3)}
							>
								مرجوع شده
							</button>
							<button
								className={section === 4 ? "tablinks active" : "tablinks"}
								onClick={() => GetServices("cancel", 4)}
							>
								لغو شده
							</button>
						</div>

						<div
							className="tabcontent"
							style={
								section === 1
									? { display: "block" }
									: section === 2
										? { display: "block" }
										: section === 3
											? { display: "block" }
											: { display: "block" }
							}
						>
							{loading ? (
								<TablePreloader />
							) : (
								services.length === 0 ?
									<p style={{ textAlign: 'center', fontSize: '1.5rem', paddingTop: '3rem' }}>
										سفارشی وجود ندارد
									</p> :
									services.map((service, index) => {
										return (
											<div className="cards__search-result" key={index}>
												<div className="cards__header">
													<span>{service.theDate}</span>
													<div>
														<span>کد رهگیری</span>
														<span>{service.trackingNumber}</span>
													</div>
													<span className="cards__situation-one">
														{service.status}
													</span>
												</div>
												<div className="cards__body">
													<div>
														<div className="cards__order">
															<span className="cards__order-title">
																روش ارسال :
															</span>
															<span className="cards__order-item">
																{service.serviceType}
															</span>
														</div>
														<div className="cards__order">
															<span className="cards__order-title">
																نوع تحویل :
															</span>
															<span className="cards__order-item">
																{service.deliveryType}
															</span>
														</div>
													</div>
													<div>
														<div className="cards__order">
															<span className="cards__order-title">شهر مقصد :</span>
															<span className="cards__order-item">
																{service.destination}
															</span>
														</div>
														<div className="cards__order">
															<span className="cards__order-title">
																نام گیرنده :
															</span>
															<span className="cards__order-item">
																{service.recipientName}
															</span>
														</div>
													</div>

													<div>
														<Link
															to={`/order-details/${service.trackingNumber}`}
															className="cards__btn"
														>
															<span>جزییات بیشتر</span>
															<img src="/img/arrow.png" alt="details" />
														</Link>
														{service.paymentStat === 'پرداخت نشده' &&
															<button
																style={{
																	width: '100%',
																	fontWeight: '500',
																	color: 'var(--primary)',
																	marginTop: '4px',
																	padding: '0.5rem 1.5rem',
																	borderRadius: '5px',
																	border: '2px solid var(--primary)',
																	background: 'trnsparent',
																}}
																onClick={() => handlePayService(service.trackingNumber)}
															>
																پرداخت
															</button>
														}
													</div>
												</div>
											</div>
										);
									})
							)}
						</div>
					</div>
				</main>
			</div>
		</section>
	);
};

export default Orders;
